import { t } from '@lingui/macro';
import { Button } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { DataTable } from 'components';
import React from 'react';
import { TransactionSourceResponse, ExpertisePointGroupTypeLabel } from 'types';

export interface AdminTransactionQueriesTableProps {
  inquiriesData: TransactionSourceResponse[];
}

export const AdminTransactionQueriesTable: React.FC<AdminTransactionQueriesTableProps> = ({ inquiriesData }) => {
  const columnHelper = createColumnHelper<TransactionSourceResponse>();

  const columns = [
    columnHelper.accessor('customerId', {
      header: t`Rapor No`,
    }),

    columnHelper.accessor('groupType', {
      header: t`Marka`,
      cell: (info) => {
        const groupType = info.getValue();
        return ExpertisePointGroupTypeLabel.get(groupType) || 'Bilinmiyor';
      },
    }),

    columnHelper.accessor('plateNo', {
      header: t`Plaka`,
    }),

    columnHelper.accessor('chassisNumber', {
      header: t`ŞASİ NO`,
    }),

    columnHelper.accessor('expertisePointName', {
      header: t`Ekspertiz Noktası`,
    }),
    columnHelper.accessor('transactionTypeName', {
      header: t`SORGU TİPİ`,
    }),

    columnHelper.accessor('transactionDate', {
      header: t`TARİH`,
      cell: (info) => {
        const date = new Date(info.getValue());
        const dateStr = date.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        const timeStr = date.toLocaleTimeString('tr-TR', {
          hour: '2-digit',
          minute: '2-digit',
        });
        return `${dateStr} ${timeStr}`;
      },
    }),
    columnHelper.accessor('amount', {
      header: t`Tutar`,
    }),

    columnHelper.accessor('expertiseReportUrl', {
      header: t`İŞLEM`,
      cell: (info) => {
        const url = info.getValue();
        return url ? (
          <Button size="sm" colorScheme="blue" onClick={() => window.open(url, '_blank')}>
            GÖRÜNTÜLE
          </Button>
        ) : null;
      },
    }),

    /*  columnHelper.accessor('createdAt', {
      header: 'Tarih',
      cell: (info) => new Date(info.getValue()).toLocaleString('tr-TR'),
    }), */

    /*  columnHelper.accessor('url', {
      header: 'URL',
      cell: (info) => {
        return (
          <Flex gap={4}>
            <Tooltip label="View">
              <IconButton
                aria-label="View"
                icon={<ViewIcon />}
                onClick={() => window.open(info.getValue(), '_blank')}
              />
            </Tooltip>
          </Flex>
        );
      },
    }), */
  ];

  return (
    <DataTable
      data={inquiriesData}
      columns={columns}
      usePagination
      tableProps={{
        variant: 'striped',
        colorScheme: 'teal',
      }}
      title={t`Sorgulama Geçmişi`}
    />
  );
};
